import { QueryOptions } from "../../Common/useQuery";
import useUserOrEmployeeQuery from "../../Common/useUserOrEmployeeQuery";
import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";

export interface PurchaseOrderTransactionDto {
  id: string;
  clientReceivingTicketId: string;
  number: string;
  purchaseOrderNumber: string;
  purchaseOrderId?: string;
  dateOfDelivery: string;
  site: PoTransactionSite;
  delivered: number;
  unit: string;
  density?: PoTransactionDensity;
  productName: string;
  productId?: string;
  supplier: PoTransactionSupplier;
  driver?: PoTransactionDriver;
  carrier?: PoTransactionCarrier;
  transport?: PoTransactionTransport;
}

interface PoTransactionSite {
  name: string;
}

interface PoTransactionSupplier {
  name: string;
  number?: string;
  supplierId?: string;
}

interface PoTransactionDriver {
  name: string;
  number?: string;
  driverId?: string;
}

interface PoTransactionTransport {
  name?: string;
  number?: string;
  transportId?: string;
}

interface PoTransactionCarrier {
  name: string;
  number?: string;
  carrierId?: string;
}

interface PoTransactionDensity {
  value: number;
  massUnit: string;
  volumeUnit: string;
}

const useGetPurchaseOrderTransactions = (poId: string, options?: QueryOptions<PurchaseOrderTransactionDto[]>) => {
  const business = useSelectedBusiness();

  return useUserOrEmployeeQuery<PurchaseOrderTransactionDto[]>(
    { path: `api/businesses/${business.id}/purchaseOrders/${poId}/transactions` },
    options);
}

export default useGetPurchaseOrderTransactions;
